import { ExpandMore } from "@mui/icons-material"
import React, { FC, Fragment } from "react"

import { Accordion } from "src/components/common/accordion"
import { Link } from "src/components/common/link"

import { create } from "src/helpers/bem"

import styles from "./SideNav.module.scss"

const bem = create(styles, "SideNav")

export type SideNavItemProps = {
  id: string
  title: string
  href?: string
  active?: boolean
  parent?: string
  child?: SideNavItemProps[]
  onClick?: () => void
}

export type SideNavProps = {
  items: ReadonlyArray<SideNavItemProps>
}

export const SideNav: FC<SideNavProps> = ({ items }) => {
  const renderChild = (childList: SideNavItemProps[]) => (
    <ul className={bem("list")}>
      {childList.map((item) => {
        const modifier = {
          "is-active": !!item?.active,
        }
        return (
          <li key={item.title} className={bem("list__item")}>
            {item?.href ? (
              <Link href={item.href} variant="base" onClick={item?.onClick}>
                <span className={bem("list__title", modifier)}>
                  {item.title}
                </span>
              </Link>
            ) : (
              <div className={bem("list__link")} onClick={item?.onClick}>
                <span className={bem("list__title", modifier)}>
                  {item.title}
                </span>
              </div>
            )}
            {item.child && renderChild(item.child)}
          </li>
        )
      })}
    </ul>
  )

  return (
    <div className={bem()}>
      {items?.map((item, i) => {
        const modifier = {
          "is-active": !!item?.active,
        }
        return item.child ? (
          <Accordion
            key={i}
            className={bem("item__accordion")}
            colorVariant="primary-yellow"
            defaultExpanded={item?.active}
            expanded={item.active ?? false}
            id={item.id}
            classNames={{
              wrapper: bem("item__accordion__wrapper"),
              tab: bem("item__accordion__tab"),
              content: bem("item__accordion__content"),
            }}
            label={
              <div
                className={bem("item__accordion__label")}
                onClick={item?.onClick}
              >
                <span className={bem("item__accordion__title", modifier)}>
                  {item.title}
                </span>
              </div>
            }
          >
            {renderChild(item.child)}
          </Accordion>
        ) : (
          <Fragment key={i}>
            {item?.href ? (
              <Link
                href={item.href}
                variant="base"
                classNames={{
                  label: bem("item__label"),
                  link: bem("item__link"),
                }}
                onClick={item?.onClick}
              >
                <span className={bem("item__title", modifier)}>
                  {item.title}
                </span>
              </Link>
            ) : (
              <div className={bem("item__label")} onClick={item?.onClick}>
                <span
                  className={bem("item__title", {
                    ...modifier,
                    "has-link": !!item?.onClick,
                  })}
                >
                  {item.title}
                </span>
                <ExpandMore
                  className={bem(
                    "item__title__icon",
                    !item.active ? "expanded" : undefined,
                  )}
                />
              </div>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}
